import * as Yup from 'yup';

const loginSchema = Yup.object().shape({
  email: Yup.string().email('yup.email').required('yup.required'),
  password: Yup.string().required('yup.required'),
});

export default loginSchema;
